<template>
  <div class="how-it-works">
    <div class="header">How it Works</div>
    <div class="steps">
      <div class="step" v-for="(step,index) in steps" :key="index">
        <div class="details">
          <div class="number">0{{index+1}}</div>
          <div class="text">{{step.text}}</div>
        </div>
        <img class="image" :src="step.image" :class="{[`n${index+1}`]:true}" />
        <img v-if="step.path" class="path" :class="{[`n${index+1}`]:true}" :src="step.path" />
      </div>
    </div>
    <controls :showLearn="false" />
  </div>
</template>

<script>
import Controls from "./Controls";
import displayMixin from "../mixins/display";

export default {
  mixins: [displayMixin],
  components: {
    Controls
  },
  computed: {
    steps() {
      return [
        {
          text: "Register new members from anywhere with just a phone number.",
          image: this.desktop
            ? "/images/hiw-step-1.png"
            : "/images/hiw-step-mobile-1.png",
          path: this.desktop
            ? "/images/hiw-step-path-1.svg"
            : "/images/hiw-step-mobile-path-1.svg"
        },
        {
          text:
            "Sign in loyal members via POS to redeem promotions automatically, securely, and in real time.",
          image: this.desktop
            ? "/images/hiw-step-2.png"
            : "/images/hiw-step-mobile-2.png",
          path: this.desktop
            ? "/images/hiw-step-path-2.svg"
            : "/images/hiw-step-mobile-path-2.svg"
        },
        {
          text:
            "View data insights from Como Hub & find and filter customers to communicate via SMS/email.",
          image: this.desktop
            ? "/images/hiw-step-3.png"
            : "/images/hiw-step-mobile-3.png"
        }
      ];
    }
  }
};
</script>


<style lang="scss" scoped>
.how-it-works {
  display: flex;
  flex-direction: column;
  align-items: center;

  > *:not(:last-child) {
    margin-bottom: 70px;
  }
  .header {
    font-size: 48px;
    font-weight: bold;
    color: #333d4d;
  }

  .steps {
    display: flex;
    flex-direction: column;
    align-items: center;
    > *:not(:last-child) {
      margin-bottom: 50px;
    }
    .step {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      .details {
        display: flex;
        width: fit-content;
        margin: 0 auto 40px auto;
        .number {
          width: 45px;
          height: 45px;
          background-color: #333d4d;
          border-radius: 50%;
          font-size: 18px;
          font-weight: bold;
          color: #fdfdfd;
          text-align: center;
          line-height: 45px;
        }
        .text {
          max-width: 300px;
          position: relative;
          top: 9px;
          left: 12px;
          font-size: 16px;
          font-weight: 300;
          line-height: 1.75;
          color: #333d4d;
        }
      }
      .image {
        height: 464px;
        z-index: 1;
      }
      .path {
        position: absolute;
        left: -700px;
        right: 0;
        top: 15px;
        bottom: 0;
        margin: 0 auto;
        height: calc(100% + 55px);

        #app.desktop &.n2 {
          transform: rotate(-1deg);
          top: 30px;
          left: -655px;
        }
      }
    }
  }

  .start-now {
    text-align: center;
    .header {
      font-size: 26px;
      font-weight: 600;
      color: #333d4d;
      margin-bottom: 15px;
    }
    .text {
      font-size: 16px;
      font-weight: 300;
      line-height: 1.75;
      color: #333d4d;
    }
  }

  // Mobile
  #app.mobile & {
    > *:not(:last-child) {
      margin-bottom: 30px;
    }

    .header {
      font-size: 26px;
    }
    .steps {
      > *:not(:last-child) {
        margin-bottom: 30px;
      }
      .step {
        .details {
          .text {
            font-size: 14px;
            max-width: 240px;
            top: 12px;
          }
        }
        .image {
          width: 82%;
          height: initial;
          &.n3 {
            width: 98%;
          }
        }
        .path {
          position: absolute;
          left: calc(-280px - 2vw);
          right: 0;
          top: 50px;
          bottom: 0;
          margin: 0 auto;
          height: calc(100% - 25px);
        }
      }
    }
    .start-now {
      text-align: center;
      max-width: 250px;
      margin-bottom: 55px;
      .header {
        font-size: 18px;
      }
      .text {
        font-size: 12px;
        line-height: 1.67;
      }
    }
  }
}
</style>
